import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import IconTile from '../common/IconTile';
import SecondaryButton from '../common/SecondaryButton';

// Webflow layout233: "Who we are" tagline + section heading + "More about
// us" button, followed by three value columns with brand icon tiles.
// Shared with AboutUs.jsx, which renders the same trio further down its page.
const VALUE_ICONS = [BalanceOutlinedIcon, HubOutlinedIcon, Diversity3OutlinedIcon];

export const getValues = t =>
  t('home.values.items', { returnObjects: true }).map((item, i) => ({ ...item, icon: VALUE_ICONS[i] }));

export const ValueItem = ({ icon, title, text }) => (
  <Box>
    <IconTile icon={icon} sx={{ mb: 2 }} />
    <Typography variant="h5" component="h3" sx={{ color: 'surface.dark', mb: 1.5 }}>
      {title}
    </Typography>
    <Typography variant="body1" sx={{ color: 'surface.contrastText' }}>
      {text}
    </Typography>
  </Box>
);

const ValuesTrio = () => {
  const { t } = useTranslation();
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { md: 'center' },
          gap: 3,
          mb: { xs: 5, md: 8 },
        }}>
        <Box>
          <Typography sx={{ color: 'primary.main', fontWeight: 600, mb: 1 }}>
            {t('home.values.eyebrow')}
          </Typography>
          <Typography variant="h3" component="h2" sx={{ color: 'surface.dark', fontSize: { xs: '2rem', md: '2.5rem' } }}>
            {t('home.values.heading')}
          </Typography>
        </Box>
        <SecondaryButton to="/about-us" sx={{ alignSelf: { xs: 'flex-start', md: 'center' } }}>
          {t('home.values.cta')}
        </SecondaryButton>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: { xs: 5, md: 6 } }}>
        {getValues(t).map(value => <ValueItem key={value.title} {...value} />)}
      </Box>
    </Container>
  );
};

export default ValuesTrio;
